import React, { useState, useEffect } from 'react'
import FetchApi from '../../customhooks/functionFetchApi'
import DataTable from 'react-data-table-component';

// แสดงรายการสาเหตุล่าช้าของเอกสาร (จาก table notetimelage)
const ViewNotetimelage = ({ jourId }) => {
    const FetchApis = new FetchApi();
    const [notelist, setNotelist] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getNotelist();
    }, [jourId])

    function getNotelist() {
        setLoading(true)
        FetchApis.FethcGet(`/notetimelage/getnotetimelageByJournalId/${jourId}`).then((res) => {
            if (res && res.data.status == 200) {
                setNotelist(res.data.data.map((item, i) => ({ ...item, numbers: i + 1 })))
            }
            setLoading(false)
        })
    }

    const columns = [
        {
            name: 'ลำดับ',
            selector: row => row.numbers,
            sortable: true,
            grow: 0.1,
        },
        {
            name: 'วันเวลา',
            selector: row => row.timecreate,
            grow: 0.4,
        },
        {
            name: 'ผู้บันทึก',
            selector: row => row.username,
            sortable: true,
            grow: 0.4,
        },
        {
            name: 'แผนก',
            selector: row => row.department,
            sortable: true,
            grow: 0.3,
        },
        {
            name: 'Rev.',
            selector: row => row.revision,
            grow: 0.1,
        },
        {
            name: 'สาเหตุล่าช้า',
            cell: row => <div style={{ whiteSpace: 'pre-wrap', padding: '5px 0' }}>{row.detailnote}</div>,
            grow: 1.5,
        },
    ];

    return (
        <div>
            <DataTable
                columns={columns}
                data={notelist}
                progressPending={loading}
                noDataComponent={<div style={{ padding: 10 }}>ยังไม่มีการบันทึกสาเหตุล่าช้า</div>}
                dense
            />
        </div>
    )
}

export default ViewNotetimelage
